import api from '@/services/utils/base';

export default class CustomConversionsApi {
  loading: boolean = false;
  error: boolean = false;

  get(params?:any) {
    this.loading = true;
    return api
      .get('/user/custom-events', {params})
      .then((res: any) => {
        this.loading = false;
        return Promise.resolve(res.data.payload);
    });
  }

  post(data:any) {
    return api
      .post('/user/custom-events',data)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      });
  }

  put(data:any) {
    return api
      .put(`/user/custom-events/${data.id}`,data)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      });
  }


}
